export const INSERT_ITEM = "LOADING_QUEUE_INSERT_ITEM";
export const ERASE_ITEM = "LOADING_QUEUE_ERASE_ITEM";
export const CLEAR_QUEUE = "LOADING_QUEUE_CLEAR_QUEUE";